import type { NovelMetadata } from './types.ts';

/**
 * YAML Front Matter のパース
 */
export function parseFrontMatter(content: string): { data: NovelMetadata; content: string } {
  if (!content.startsWith('---')) return { data: {}, content };
  const endMatch = content.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n/);
  if (!endMatch) return { data: {}, content };

  const yamlText = endMatch[1];
  const body = content.slice(endMatch[0].length);
  const data: NovelMetadata = {};

  for (const line of yamlText.split('\n')) {
    const colonIndex = line.indexOf(':');
    if (colonIndex > 0) {
      const key = line.slice(0, colonIndex).trim();
      const value = line.slice(colonIndex + 1).trim();
      const unquoted = value.replace(/^["']|["']$/g, '').trim();

      if (key === 'tags') {
        const cleanVal = unquoted.replace(/^\[|\]$/g, '').trim();
        data.tags = cleanVal
          ? cleanVal
              .split(/[,，\s]+/)
              .map((t) => t.replace(/^["']|["']$/g, '').trim())
              .filter(Boolean)
          : [];
      } else if (key === 'char_count') {
        data.char_count = Number(unquoted);
      } else if (unquoted === 'true') (data as Record<string, unknown>)[key] = true;
      else if (unquoted === 'false') (data as Record<string, unknown>)[key] = false;
      else if (!Number.isNaN(Number(unquoted)) && unquoted !== '')
        (data as Record<string, unknown>)[key] = Number(unquoted);
      else if (key === 'description') {
        // あらすじの改行エスケープ（\n）を復元
        (data as Record<string, unknown>)[key] = unquoted.replace(/\\n/g, '\n');
      } else (data as Record<string, unknown>)[key] = unquoted;
    }
  }

  return { data, content: body };
}
